module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-time-row"
  }, [_c('div', {
    staticClass: "ds-time-cell"
  }, [_c('v-text-field', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "type": "time",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ds-time-cell"
  }, [(_vm.showRemove && !_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-remove",
    attrs: {
      "slot": "activator",
      "icon": "",
      "color": _vm.colors.remove
    },
    on: {
      "click": _vm.removeTime
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.remove))])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.remove)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd && !_vm.isReadOnly) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "action-add",
    attrs: {
      "slot": "activator",
      "icon": "",
      "color": _vm.colors.add
    },
    on: {
      "click": _vm.addTime
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.icons.add))])], 1), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.labels.add)
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9de2f668","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleTime.vue
// module id = 183
// module chunks = 0